const stringMatchFilter = (compareStr: string, val: string) => compareStr.toLowerCase().indexOf(val.toLowerCase().trim()) !== -1;

export const matchData = (item: { fundsname: string; isin: string }, value: string) => stringMatchFilter(item.fundsname, value) || stringMatchFilter(item.isin, value);
